import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading, setProgressDialog } from "../utility";
import { httpRequestFunc } from "../../../common/config/httpClient";
import { notificationSuccessMessage } from "../../../common/config/message";
import {
  cancelKerryOrderApi,
  createKerryOrderApi,
  printKerryOrderApi,
  trackingKerryOrderApi,
  updateKerryTrackingOrderApi,
} from "../../../common/api/kerryApi";
import { fetchAsyncOrder } from "../order/orderthunk";
import moment from "moment";
import { fetchAsyncReportSipping } from "../report/reportThunk";
import { updateBestExpressTrackingOrderApi } from "../../../common/api/bestexpressApi";

export const createAsyncKerryOrder = createAsyncThunk(
  "kerry/createAsyncKerryOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        createKerryOrderApi(data.orderId, data.data)
      );
      baseThunk.dispatch(setProgressDialog(false));
      notificationSuccessMessage(
        "ส่งข้อมูลสร้าง Tracking แล้ว กรุณาตรวจสอบรายการสั่งซื้อ"
      );
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      if (typeof data.callback !== `undefined`) {
        data.callback(false);
      }
      if (typeof data.filter !== `undefined`) {
        const f = { ...data.filter };
        f.start = moment(f.start).format("YYYY-MM-DD");
        f.end = moment(f.end).format("YYYY-MM-DD");
        baseThunk.dispatch(fetchAsyncReportSipping(f));
      }
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);

export const cancelAsyncKerryOrder = createAsyncThunk(
  "kerry/cancelAsyncKerryOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        cancelKerryOrderApi(data.orderId)
      );
      baseThunk.dispatch(setProgressDialog(false));
      notificationSuccessMessage(
        "ส่งข้อมูลสร้าง Tracking แล้ว กรุณาตรวจสอบรายการสั่งซื้อ"
      );
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      if (typeof data.filter !== `undefined`) {
        const f = { ...data.filter };
        f.start = moment(f.start).format("YYYY-MM-DD");
        f.end = moment(f.end).format("YYYY-MM-DD");
        baseThunk.dispatch(fetchAsyncReportSipping(f));
      }
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);
export const updateTrackingAsyncKerryOrder = createAsyncThunk(
  "kerry/updateTrackingAsyncKerryOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        data?.provider === "bestexpress"
          ? updateBestExpressTrackingOrderApi(data.update)
          : updateKerryTrackingOrderApi(data.update)
      );
      baseThunk.dispatch(setProgressDialog(false));
      notificationSuccessMessage("อัพเดตสถานะ Tracking แล้ว");
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      baseThunk.dispatch(fetchAsyncOrder(data.filter));
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);

export const trackingAsyncKerryOrder = createAsyncThunk(
  "kerry/trackingAsyncKerryOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        trackingKerryOrderApi(data.id)
      );
      baseThunk.dispatch(setProgressDialog(false));
      // notificationSuccessMessage("ส่งข้อมูลสร้าง Tracking แล้ว กรุณาตรวจสอบรายการสั่งซื้อ")
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);

export const printAsyncKerryOrder = createAsyncThunk(
  "kerry/printAsyncKerryOrder",
  async (data, baseThunk) => {
    baseThunk.dispatch(setProgressDialog(true));
    baseThunk.dispatch(setLoading({ loading: "LOADING" }));
    try {
      const response = await httpRequestFunc(
        baseThunk,
        printKerryOrderApi(data)
      );
      baseThunk.dispatch(setProgressDialog(false));
      notificationSuccessMessage(
        "ส่งข้อมูลสร้าง Tracking แล้ว กรุณาตรวจสอบรายการสั่งซื้อ"
      );
      baseThunk.dispatch(setLoading({ loading: "SUCCESS" }));
      return response.data;
    } catch (e) {
      baseThunk.dispatch(setProgressDialog(false));
      baseThunk.dispatch(setLoading({ loading: "ERROR" }));
      console.log(e);
    }
  }
);
